import IndexLayout from "../layouts/IndexLayout";
import MainLayout from "../layouts/MainLayout";
import PagesLayaut from '../layouts/PagesLayaut'
import { createBrowserRouter } from "react-router-dom";
import Productos from './Productos/Productos'
import Usuarios from './Usuarios/Usuarios'
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import PageDetail from './PageDetail/PageDetail';
import PageProductos from "./PageProductos/PageProductos";
import Pedidos from "./Pedidos/Pedidos";

export const createRouter = (logo) => createBrowserRouter([
    {
        path: "/",
        element: <IndexLayout logo={logo} />,
    },
    {
        path: "/producto/:idProducto/:producto",
        element: <PagesLayaut logo={logo} />,
        children: [
            {
                index: true,
                element: <PageDetail />,
            },
        ]
    },
    {
        path: "/productos",
        element: <PagesLayaut logo={logo} />,
        children: [
            {
                index: true,
                element: <PageProductos />,
            },
        ]
    },
    {
        path: "/dashboard",
        element: <MainLayout logo={logo} />,
        children: [
            {
                index: true,
                element: <Main logo={logo} />,
            },
            {
                path: "productos",
                element: <Productos logo={logo} />,
            },
            {
                path: "usuarios",
                element: <Usuarios logo={logo} />,
            },
            {
                path: "banners",
                element: <Banners logo={logo} />,
            },
            {
                path: "contacto",
                element: <Contacto logo={logo} />,
            },
            {
                path: "categorias",
                element: <Categorias logo={logo} />,
            },
            {
                path: "codigos",
                element: <Codigos logo={logo} />,
            },
            {
                path: "pedidos",
                element: <Pedidos logo={logo} />,
            },
        ],
    },
]);
